export function normalize(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
/** Returns the substring positions (in normalized form) where `needle` matches `hay`. */
export function findMatches(hay, needle) {
    if (!needle)
        return [];
    const nh = normalize(hay);
    const nn = normalize(needle);
    if (!nn)
        return [];
    const out = [];
    let from = 0;
    while (from < nh.length) {
        const idx = nh.indexOf(nn, from);
        if (idx < 0)
            break;
        out.push([idx, idx + nn.length]);
        from = idx + nn.length;
    }
    return out;
}
const HTML_ESCAPE = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
function escape(s) {
    return s.replace(/[&<>"']/g, (c) => HTML_ESCAPE[c] ?? c);
}
/** Wraps accent-insensitive matches of `needle` in `<mark>`. Returns dangerouslySetInnerHTML payload. */
export function highlight(text, needle) {
    if (!needle)
        return { __html: escape(text) };
    const matches = findMatches(text, needle);
    if (matches.length === 0)
        return { __html: escape(text) };
    let result = '';
    let cursor = 0;
    for (const [start, end] of matches) {
        result += escape(text.slice(cursor, start));
        result += `<mark class="bg-yellow-200 text-gray-900 rounded px-0.5 dark:bg-yellow-500/40 dark:text-gray-50">${escape(text.slice(start, end))}</mark>`;
        cursor = end;
    }
    result += escape(text.slice(cursor));
    return { __html: result };
}
//# sourceMappingURL=normalize.js.map